/** First wait after a dropped socket, and the longest wait between two attempts. */
export const RECONNECT_BASE_MS = 1000;
export const RECONNECT_CAP_MS = 30000;

/**
 * How long to wait before reconnect attempt `attempt` (0 = the first one after a drop): the ceiling doubles from
 * `base` up to `cap`, and the wait is somewhere between half the ceiling and the ceiling ("equal jitter"), so the
 * clients that lost the server at the same moment do not all come back in step.
 * 0: 0.5-1 s, 1: 1-2 s, 2: 2-4 s, 3: 4-8 s, 4: 8-16 s, 5 and later: 15-30 s.
 */
export function reconnectDelay(attempt, random = Math.random, base = RECONNECT_BASE_MS, cap = RECONNECT_CAP_MS) {
    const step = Math.max(0, Math.floor(Number(attempt) || 0));
    const ceiling = Math.min(cap, base * Math.pow(2, Math.min(step, 30)));
    const share = Math.min(1, Math.max(0, Number(random()) || 0));
    return Math.round(ceiling / 2 + share * ceiling / 2);
}

/** The custom parameters a socket is opened with, as one comparable string (the order they were set in does not matter). */
export function socketParamsKey(params) {
    return Object.keys(params || {}).sort().map(key => key + "=" + params[key]).join("&");
}
